export const GET_EOD_REPORTS_LOG_REQUEST = "GET_EOD_REPORTS_LOG_REQUEST";
export const GET_EOD_REPORTS_LOG_SUCCESS = "GET_EOD_REPORTS_LOG_SUCCESS";
export const GET_EOD_REPORTS_LOG_FAILURE = "GET_EOD_REPORTS_LOG_FAILURE";
